import { getHazard, HAZARD_BASE, intensity } from "@/lib/hazard";

export const BASEMAPS = {
  satellite: {
    label: "Satellite",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attribution: "Imagery &copy; Esri, Maxar, Earthstar Geographics",
    labels: "https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
  },
  dark: {
    label: "Dark",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}",
    attribution: "&copy; Esri, HERE, Garmin, OpenStreetMap contributors",
    labels: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}",
  },
};

// Quick-zoom presets: [[south, west], [north, east]]; global uses a centre + zoom.
export const REGIONS = [
  { id: "global", label: "Global" },
  { id: "caribbean", label: "Caribbean", bounds: [[8, -88], [27.5, -58]] },
  { id: "asia", label: "Asia", bounds: [[-11, 60], [55, 150]] },
  { id: "europe", label: "Europe", bounds: [[35, -11], [71, 40]] },
  { id: "africa", label: "Africa", bounds: [[-35, -18], [37, 52]] },
  { id: "americas", label: "Americas", bounds: [[-56, -130], [60, -34]] },
  { id: "middle_east", label: "Middle East", bounds: [[12, 25], [42, 63]] },
  { id: "pacific", label: "Pacific", bounds: [[-48, 120], [25, 205]] },
];

export const inRegion = (lat, lon, [[s, w], [n, e]]) => {
  const x = e > 180 && lon < 0 ? lon + 360 : lon;
  return lat >= s && lat <= n && x >= w && x <= e;
};

export const GLOBAL_VIEW = { center: [18, 10], zoom: 2 };

const ANOM = { unexplained_anomaly: "#FF2A2A", explained_anomaly: "#FF9500" };

export const pointColor = (d, selectedUid) =>
  d.uid === selectedUid ? "#FFFFFF" : ANOM[d.triage_status] || HAZARD_BASE[getHazard(d)] || "#00F0FF";

export const pointRadius = (d) => {
  const base = d.triage_status === "unexplained_anomaly" ? 7 : 5;
  return base + Math.round(intensity(d) * 6);
};

export const hazardDetail = (d) => {
  const h = getHazard(d);
  if (h === "seismic" && d.metrics) return `max M${d.metrics.max_magnitude} · ${d.metrics.recent_count} quakes/7d`;
  if (h === "fire" && d.metrics)
    return `${d.metrics.temperature_f}°F · RH ${d.metrics.relative_humidity}% · wind ${d.metrics.wind_mph}mph`;
  return null;
};
